export type SearchHistoryEntry = {
  label: string;
  description: string;
  kind: string;
  path: string;
};

export const SEARCH_HISTORY_LIMIT = 8;

export function searchHistoryStorageKey(
  userId: string,
  tenantId: string,
  category: "favorites" | "recent",
) {
  return `etain-hub:search:${category}:${userId}:${tenantId}`;
}

export function parseSearchHistory(value: string | null): SearchHistoryEntry[] {
  if (!value) return [];
  try {
    const parsed: unknown = JSON.parse(value);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((entry): entry is SearchHistoryEntry =>
      Boolean(
        entry &&
        typeof entry === "object" &&
        typeof entry.label === "string" &&
        typeof entry.description === "string" &&
        typeof entry.kind === "string" &&
        typeof entry.path === "string",
      ),
    );
  } catch {
    return [];
  }
}

export function rememberSearchEntry(
  entries: SearchHistoryEntry[],
  entry: SearchHistoryEntry,
  limit = SEARCH_HISTORY_LIMIT,
) {
  return [entry, ...entries.filter((candidate) => candidate.path !== entry.path)].slice(0, limit);
}

export function toggleFavoriteSearchEntry(
  entries: SearchHistoryEntry[],
  entry: SearchHistoryEntry,
  limit = SEARCH_HISTORY_LIMIT,
) {
  return entries.some((candidate) => candidate.path === entry.path)
    ? entries.filter((candidate) => candidate.path !== entry.path)
    : rememberSearchEntry(entries, entry, limit);
}
